import {apiInstance} from "../api";

const route = '/flat-listings';

// «Выставка квартир»: ECI old's KPI report (who listed which flats in a period, their grades)
export class FlatListingsService {
  // {from, to: 'YYYY-MM-DD', user, complexId}
  static fetchReport(params) {
    return apiInstance.get(route, {params});
  }

  static fetchOptions() {
    return apiInstance.get(`${route}/options`);
  }
}
